import { ZENDESK_WIDGET_ZINDEX } from 'shared/constants';

export const getBaseSettings = {
    position: { horizontal: 'right', vertical: 'top' },
    offset: {
        horizontal: '166px',
        vertical: '4px',
        mobile: {
            horizontal: '166px',
            vertical: '4px',
        },
    },
    zIndex: ZENDESK_WIDGET_ZINDEX,
};

export const getZDContactSettings = (isVectorPro: boolean, userName: string | undefined) => {
    const name = userName ?? '';
    return isVectorPro ? vectorProPrefill(name) : vectorCorePrefill(name);
};
export const getZDChatSettings = (isOnline: boolean) => {
    return isOnline ? onlineChatSettings : offlineChatSettings;
};

const onlineChatSettings = {
    contactOptions: {
        enabled: true,
    },
    chat: {
        departments: {
            enabled: ['Catapult Support'],
            select: 'Catapult Support',
        },
        suppress: false,
    },
};

const offlineChatSettings = {
    chat: {
        suppress: true,
    },
};

const vectorCorePrefill = (userName: string) => {
    return {
        contactForm: {
            fields: [
                {
                    id: 360000288275,
                    prefill: { '*': userName },
                },
            ],
            ticketForms: [
                {
                    id: 360000025935,
                    fields: [
                        {
                            id: 6083233463311,
                            prefill: { '*': 'vector_core_sol' },
                        },
                    ],
                },
            ],
        },
    };
};
const vectorProPrefill = (userName: string) => {
    return {
        contactForm: {
            fields: [
                {
                    id: 360000288275,
                    prefill: { '*': userName },
                },
            ],
            ticketForms: [
                {
                    id: 360000025935,
                    fields: [
                        {
                            id: 6083233463311,
                            prefill: { '*': 'vector_pro_sol' },
                        },
                    ],
                },
            ],
        },
    };
};
